import {isLocalStoragePhotoUrl} from 'platform/foundation';

import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

export function getResizeUrl(src: string | Nullish, height: number) {
  if (isNil(src)) {
    return null;
  }
  return isLocalStoragePhotoUrl(src) ? src : `${src}&height=${height}`;
}
